module.exports = __webpack_public_path__ + "img/antes_despues_250.261c33e5.png";